import { Base } from "./Base";
import { BadRequestException, ForbiddenException, NotFoundException, throwExpected, UnauthorizedException, UnprocessableEntityException, } from "./exceptions";
class SSOService extends Base {
    /**
     * Get SSO details by business handle
     */
    async getSSOByBusinessHandle(handle) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/sso?handle=${handle}`;
        const json = await throwExpected(async () => fetch.get(url), {
            404: (error) => { var _a; return new NotFoundException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : "SSO not found"); },
            400: (error) => { var _a; return new BadRequestException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : "Handle is required"); },
        });
        return json;
    }
    /**
     * Get SSO details by domain
     */
    async getSSOByDomain(domain) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/sso?domain=${domain}`;
        const json = await throwExpected(async () => fetch.get(url), {
            404: (error) => { var _a; return new NotFoundException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : "SSO not found"); },
            400: (error) => { var _a; return new BadRequestException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : "Domain is required"); },
        });
        return json;
    }
    /**
     * Get OIDC SSO configuration
     */
    async getRemoteOIODCConfiguration(remoteOidcConfigUrl) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/sso/configuration?url=${remoteOidcConfigUrl}`;
        const json = await throwExpected(async () => fetch.get(url), {
            422: (error) => new UnprocessableEntityException(error === null || error === void 0 ? void 0 : error.body.message),
            404: (error) => { var _a; return new NotFoundException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : "SSO not found"); },
        });
        return json;
    }
    /**
     * Get SSO provider connection link
     */
    async getSSOProviderConnectionLink(providerAlias, clientId) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/sso/account-link?provider=${providerAlias}&clientId=${clientId}`;
        const json = await throwExpected(async () => fetch.get(url), {
            404: (error) => { var _a; return new NotFoundException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : "SSO provider found"); },
            403: (error) => new ForbiddenException(error === null || error === void 0 ? void 0 : error.body.message),
            401: (error) => new UnauthorizedException(error === null || error === void 0 ? void 0 : error.body.message),
            422: (error) => {
                var _a;
                return new UnprocessableEntityException((_a = error === null || error === void 0 ? void 0 : error.body.message) !== null && _a !== void 0 ? _a : `Failed to retrieve link for provider ${providerAlias}`);
            },
        });
        return json;
    }
}
export { SSOService };
